/** Аналог Array.prototype.findLastIndex (ES2023) на обратном цикле — O(n), O(1) памяти */
export const findLastIndex = <T>(array: T[], predicate: (item: T) => boolean): number => {
  for (let index = array.length - 1; index >= 0; index--) {
    if (predicate(array[index])) {
      return index;
    }
  }

  return -1;
};
